import { UnitedStatesPurchaseCost } from '..'

export const IllinoisPurchaseCost = { ...UnitedStatesPurchaseCost }
